import { QRCode, QRCodeImage } from "@/components/ui/qr-code";
import { cn } from "@/lib/utils";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "./card";

interface CardQRCodeProps {
	url: string;
	title?: string;
	description?: string;
	alt?: string;
	className?: string;
}

export default function CardQRCode({
	url,
	title,
	description,
	alt,
	className,
}: CardQRCodeProps) {
	return (
		<Card className={cn("bg-transparent border-none shadow-none", className)}>
			{title || description ? (
				<CardHeader className="items-center justify-center text-center space-y-4">
					{title && <CardTitle>{title}</CardTitle>}
					{description && <CardDescription>{description}</CardDescription>}
				</CardHeader>
			) : null}
			<CardContent>
				<QRCode
					value={url}
					size={512}
					className="p-2 rounded-2xl border-2 border-primary/20"
				>
					<QRCodeImage alt={alt || "QR Code"} />
					{/* <QRCodeDownload format="png" filename="qr-image" asChild>
                        <Button size="sm">Download PNG</Button>
                    </QRCodeDownload> */}
				</QRCode>
			</CardContent>
		</Card>
	);
}
